import { createReducer, on } from '@ngrx/store';
import { configInitialState } from './config.state';
import * as actions from './config.actions';

export const configReducer = createReducer(
  configInitialState,
  on(actions.setEpubDictionary, (state, { epub }) => ({ ...state, epub })),
);
